import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ChannelFragmentDoc } from '../../../../../features/messages/graphql/fragments/generated/Channel';
import { ChannelUserFragmentDoc } from '../../../../../features/messages/graphql/fragments/generated/ChannelUser';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateChannelMutationVariables = Types.Exact<{
  data: Types.CreateChannelInput;
}>;


export type CreateChannelMutation = { createChannel?: { success?: boolean | null, errorCode?: Types.CreateChannelErrorCodeEnum | null, channel?: { id: string, name: string, icon?: string | null, accessType: Types.ChannelAccessTypeEnum, description?: string | null, createdAt: string, allowedToPost?: Types.ChannelAllowedToPostEnum | null, topic: string, channelUser?: { id: string, lastViewedAt: string, unreadCount?: number | null } | null, userPermissions: Array<{ action: Types.ChannelActionsEnum, subject: Types.ChannelSubjectsEnum }> } | null } | null };


export const CreateChannelDocument = /*#__PURE__*/ gql`
    mutation createChannel($data: CreateChannelInput!) {
  createChannel(data: $data) {
    success
    channel {
      ...Channel
    }
    errorCode
  }
}
    ${ChannelFragmentDoc}
${ChannelUserFragmentDoc}`;

export function useCreateChannelMutation() {
  return Urql.useMutation<CreateChannelMutation, CreateChannelMutationVariables>(CreateChannelDocument);
};